import { Component, OnInit } from '@angular/core';

import { DEPARTMENT_TYPE_ARBITRATION } from 'src/app/core/constants';

@Component({
  selector: 'app-arbitration-home',
  templateUrl: './arbitration-home.component.html',
  styleUrls: ['./arbitration-home.component.scss']
})
export class ArbitrationHomeComponent implements OnInit {
  /**
   * Definição da identificão da sessão/depto Arbitragem
   */
  public departmentType: string = DEPARTMENT_TYPE_ARBITRATION;

  constructor() { }

  ngOnInit(): void {
  }

}
